import { ShowIf } from '../../../../../../../../components/ShowIf';
import { AnnualRent } from '../../components/AnnualRent';
import { Bathrooms } from '../../components/Bathrooms';
import { Bedrooms } from '../../components/Bedrooms';
import { GarageBays } from '../../components/GarageBays';
import { Occupied } from '../../components/Occupied';
import { SquareFeet } from '../../components/SquareFeet';
import '../../../../../../../../scss/_rentalUnitsMobileUnitInfo.scss';

interface MobileUnitInformationRowsProps {
    unitGuid: string;
    includeOccupied: boolean;
    isReview?: boolean;
}

export const MobileUnitInformationRows: React.FC<MobileUnitInformationRowsProps> = ({
    unitGuid,
    includeOccupied,
    isReview = false,
}) => {
    const itemClassName = (panelLocation: string) => {
        return isReview ? '' : `mobileUnitInformation-row-col ${panelLocation}`;
    };

    return (
        <>
            <div className='mobileUnitInformation-row'>
                <ShowIf showIf={includeOccupied}>
                    <div className={itemClassName('left')}>
                        <Occupied
                            unitGuid={unitGuid}
                            showLabel={true}
                            required={true}
                            isReview={isReview}
                        />
                    </div>
                </ShowIf>
                <div className={itemClassName('right')}>
                    <AnnualRent
                        unitGuid={unitGuid}
                        showLabel={true}
                        required={true}
                        isReview={isReview}
                    />
                    <SquareFeet
                        unitGuid={unitGuid}
                        showLabel={true}
                        required={true}
                        isReview={isReview}
                    />
                    <Bedrooms
                        unitGuid={unitGuid}
                        showLabel={true}
                        required={true}
                        isReview={isReview}
                    />
                    <Bathrooms
                        unitGuid={unitGuid}
                        showLabel={true}
                        required={true}
                        isReview={isReview}
                    />
                    <GarageBays
                        unitGuid={unitGuid}
                        showLabel={true}
                        required={true}
                        isReview={isReview}
                    />
                </div>
            </div>
        </>
    );
};
